var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 45,
    viewBox: "0 0 58 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.3433 13.0716L26.593 42.0806C25.2998 43.5316 23.431 44.2568 21.5622 44.2568C19.6935 44.2568 17.8247 43.5316 16.5314 42.0806L2.15627 27.5761C-0.718757 24.8203 -0.718757 20.1798 2.15627 17.4235C4.88755 14.5226 9.48663 14.5226 12.2184 17.4235L21.5622 26.7059L45.2817 2.91896C48.013 0.0180609 52.612 0.0180609 55.3438 2.91896C58.2188 5.6753 58.2188 10.3158 55.3433 13.0716Z",
    fill: "#A0FF42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrue);
export default __webpack_public_path__ + "static/media/true.5a401c73217846b0d03a21433668bbd2.svg";
export { ForwardRef as ReactComponent };